import { defineComponent as _defineComponent } from 'vue';
import { library } from "@fortawesome/fontawesome-svg-core";
import { faCheckSquare, faCompress } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import DefaultOperations from "@/components/History/CurrentHistory/HistoryOperations/DefaultOperations.vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'HistoryOperations',
    props: {
        history: null,
        hasMatches: { type: Boolean },
        expandedCount: null,
        showSelection: { type: Boolean },
        isMultiViewItem: { type: Boolean }
    },
    emits: ["update:show-selection", "collapse-all", "update:operation-running"],
    setup(__props, { emit }) {
        const props = __props;
        library.add(faCheckSquare, faCompress);
        function toggleSelection() {
            emit("update:show-selection", !props.showSelection);
        }
        function onUpdateOperationStatus(updateTime) {
            emit("update:operation-running", updateTime);
        }
        return { __sfc: true, props, emit, toggleSelection, onUpdateOperationStatus, faCheckSquare, faCompress, FontAwesomeIcon, DefaultOperations };
    }
});
